import { trim } from 'lodash';
import { mixed, object, string } from 'yup';

import { TemplateEntryType } from '../../../data/types/api/graphql';
import { parseTimeToMinutes } from '../../../data/utils/date.utils';
import { messages, nanNumber } from '../../../data/utils/form.utils';

export const schema = object()
  .shape({
    name: string().transform(trim).required(messages.required.id).default(''),
    type: mixed<TemplateEntryType>()
      .oneOf(Object.values(TemplateEntryType))
      .required(messages.required.id)
      .default(TemplateEntryType.AppointmentBlock),
    startTime: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    endTime: string()
      .transform(trim)
      .test('end-time', messages.invalidEndTime.id, function t(value) {
        const { startTime } = this.parent;
        if (!startTime || !value) return true;
        const start = parseTimeToMinutes(startTime);
        const end = parseTimeToMinutes(value);
        if (start === null || end === null) return false;
        return end > start;
      })
      .required(messages.required.id)
      .default(''),
    minutes: nanNumber().required(messages.required.id).default(15),
    appointments: nanNumber()
      .when('type', {
        is: (type: TemplateEntryType) => type !== TemplateEntryType.Exception,
        then: currentSchema =>
          currentSchema
            .required(messages.required.id)
            .min(1, { error: 'template.entry.error.appointments', min: 1 }),
      })
      .default(1),
  })
  .required()
  .noUnknown();
